module.exports = __webpack_public_path__ + "media/images/EN-528d6bcfafa6307793ed060ff27e3c9c.png";